import script from "./AdminNoticeWrite.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminNoticeWrite.vue?vue&type=script&setup=true&lang=ts"

import "./AdminNoticeWrite.vue?vue&type=style&index=0&id=13c95f55&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13c95f55"]])

export default __exports__